// extracted by mini-css-extract-plugin
module.exports = {"title":"modal_confirmation_header_no_close-module__title--2K8zU"};